// extracted by mini-css-extract-plugin
export default {"title":"index_title_nt0eW","list":"index_list_1SNCb","red":"index_red_JT2m6","black":"index_black_6wOuy"};